import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {validationmethod} from '../../shared/common/validationmethod';
import {TrnxCommonTs} from '../../shared/common/trnxCommonTs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {CommonService} from '../../shared/services/common.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {LocalStorageSettingsService} from '../../shared/services/local-storage-settings.service';
import {LoginService} from '../../shared/services/login.service';
import {ReportTemplateButton} from '../../shared/common/ReportTemplateButton';
import {Actionbutton} from '../../shared/common/Actionbutton';
import {TrnxBasePopupScreenComponent} from '../trnx-base-popup-screen/trnx-base-popup-screen.component';
import {TrnxchildBaseScreenComponent} from '../trnxchild-base-screen/trnxchild-base-screen.component';
import {ReportTemplatePopupComponent} from '../report-template-popup/report-template-popup.component';
import {AssignUserRolePopupComponent} from './assign-user-role-popup/assign-user-role-popup.component';
import {FiledownloadComponent} from '../../shared/common/filedownload.component';
import {AsignUserRoleService} from '../../shared/services/asign-user-role.service';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';


/*
   @Author:Ravi G
   @Date:28-06-2022
*/
@Component({
    selector: 'app-assign-user-role',
    templateUrl: './assign-user-role.component.html',
    styleUrls: ['./assign-user-role.component.scss'],
    standalone: false
})
export class AssignUserRoleComponent implements OnInit {

  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  columnDefs;

  rowClassRules;

  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  pageSize;

  components: any;

  overlayNoRowsTemplate;

  listObjectDropDown: any = [];

  dynamicData = [];

  trnxScreenId;

  ngModelObject = [];

  ngModelObjectDivision = [];

  bootstrapColumn = 0;

  //dropDowns = [];

  retrieveObject: any = [];

  headerNameHtml = '';

  buttonName;

  tableID = '';

  agGridShow = false;

  retrieveNgModelCreation: any = [];

  screenType;

  value;

  recordsStart = 0;

  screenTypeTOrM = '';

  backgroundColorScreen = '';

  backgroundColorButton = '';

  isdisable: boolean = false;

  buttonIdList:any = [];

  getData: any = [];

  userData:any=[];

  roleData:any=[];

  importExportTableName = "assignuserrole";
  

  //constructor
  constructor(
    private dialog: MatDialog, private commonService: CommonService, private localStorage: LocalStorageSettingsService,private asignUserRoleService:AsignUserRoleService,
    private snackBar:MatSnackBar,private spinner:NgxUiLoaderService,private userRoutingModule: UserRoutingModule,
            private reportLinkService:ReportlinksserviceService
  ) {
    this.components = {

      buttonRenderer: Actionbutton,

    };

  }

  async ngOnInit() {
    /* @added by Chandra R
        @date 01-01-2025
        @@desc Below code enable and disable the buttons  in UI based on permission
    */
   this.backgroundColorButton = this.localStorage.getSettings("ColorA");

    let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorage.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

      sortable: true,

      resizable: true,

      filter: true

    };
    
    this.columnDefs = [
      {
        headerName: 'Action',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this)
        },
        pinned: 'left',
        lockPinned: true,
        width: 150,
      },

      {
        headerName: 'Assign User Role Id',
        headerTooltip: 'Assign User Role Id',
        tooltipValueGetter: (params) =>
          'Assign User Role Id : ' + params.value,
        field: 'assignuserroleid',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'User Role Id',
        headerTooltip: 'User Role Id',
        tooltipValueGetter: (params) =>
          'User Role Id : ' + params.value,
        field: 'roleid',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Company Name',
        headerTooltip: 'Company Name',
        tooltipValueGetter: (params) =>
          'Company Name : ' + params.value,
        field: 'compname',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Workspace Name',
        headerTooltip: 'Workspace Name',
        tooltipValueGetter: (params) =>
          'Workspace Name : ' + params.value,
        // field: 'dnsname',
        field: 'tenantname',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'User Name',
        headerTooltip: 'User Name',
        tooltipValueGetter: (params) =>
          'User Name : ' + params.value,
        field: 'username',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Role Type',
        headerTooltip: 'Role Type',
        tooltipValueGetter: (params) =>
          'Role Type : ' + params.value,
        field: 'rolename',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Created By',
        headerTooltip: 'Created By',
        tooltipValueGetter: (params) =>
          'Created By : ' + params.value,
        field: 'createdBy',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Created Date',
        headerTooltip: 'Created Date',
        tooltipValueGetter: (params) =>
          'Created Date : ' + params.value,
        field: 'createdDate',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Last Modified By',
        headerTooltip: 'Last Modified By',
        tooltipValueGetter: (params) =>
          'Last Modified By : ' + params.value,
        field: 'lastModifiedBy',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Last Modified Date',
        headerTooltip: 'Last Modified Date',
        tooltipValueGetter: (params) =>
          'Last Modified Date: ' + params.value,
        field: 'lastModifiedDate',
        filter: 'agTextColumnFilter',
        width: 180,
      },



    ];
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");

    this.backgroundColorButton = this.localStorage.getSettings("ColorA");

  }

  onPaginationChangedReturn() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI) {

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalPages = this.gridAPI.paginationGetTotalPages();

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

    /*this.recordsStart = this.recordsStart + 100;

    this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

    console.log(this.retrieveObject);

    if (this.retrieveObject.length == 0) {

      this.recordsStart = this.recordsStart - 100;

    }

    else {

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridAPI.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    /*if (this.recordsStart > 0) {

      this.recordsStart = this.recordsStart - 100;

      this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

      console.log(this.retrieveObject);

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridAPI.paginationGoToLastPage();

  }

  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    this.gridAPI = params.api;
    // this.gridAPI.setGridOption('paginationPageSize', 10)
    this.getData = [];
    this.gridColumnAPI = params.columnApi;

    this.retrieveAssignUsersRoleByDnsId();



  }
  //retrieve Assign Users Role By DnsId
  retrieveAssignUsersRoleByDnsId(){
    var dnsId = localStorage.getItem('dnsName');
    this.asignUserRoleService.retrieveAssignUsersRoleByDnsId().subscribe(response=>
      {
        if (response.error == true) {

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        }
        else {

          this.spinner.stop();
          console.log('assignUserRoleData');
          console.log(response);
          this.gridAPI.setGridOption('rowData', response);

        }
      }
    );
  }

  retrieveChildData(e) {

    console.log(e);

    let rowData = e.data;

    console.log(rowData);


    var obj = {
      "assignuserroleid": e.data.assignuserroleid,
      "userid": e.data.userid,
      "roleid": e.data.roleid,
      "createdBy": e.data.createdBy,
      "createdDate": e.data.createdDate,
      "lastModifiedBy": e.data.lastModifiedBy,
      "lastModifiedDate": e.data.lastModifiedDate,
      "username": e.data.username,
      "rolename": e.data.rolename,
      "tenantid": e.data.tenantid,
      "companyid":e.data.companyid,
    }
    let dialogRef = this.dialog.open(AssignUserRolePopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result=>{
      this.retrieveAssignUsersRoleByDnsId();
    })


  }

  // Aggrid Edit function
  editIcon(e) {

    console.log(e+" ===================================");

    let rowData = e.rowData;
    console.log(rowData)
    console.log(rowData);

    var obj = {
      "assignuserroleid": e.rowData.assignuserroleid,
      "userid": e.rowData.userid,
      "roleid": e.rowData.roleid,
      "createdBy": e.rowData.createdBy,
      "createdDate": e.rowData.createdDate,
      "lastModifiedBy": e.rowData.lastModifiedBy,
      "lastModifiedDate": e.rowData.lastModifiedDate,
      "username": e.rowData.username,
      "rolename": e.rowData.rolename,
      "tenantid": e.rowData.tenantid,
      "companyid": e.rowData.companyid,
      "compname": e.rowData.compname,
      // "dnsname": e.rowData.dnsname,
      "dnsname": e.rowData.tenantname,
      "workspaceid": e.rowData.workspaceid,

    }
    let dialogRef = this.dialog.open(AssignUserRolePopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result=>{
      this.retrieveAssignUsersRoleByDnsId();
    })

  }

  async deleteIcon(e) {
    //console.log(e.rowData.assignuserroleid +" " +"assignuserroleid"+" "+"assignuserrole");

    if (confirm("Are you sure you want to delete the record ?") == true) {

      (await this.commonService.deleteRecordPermanent("assignuserrole", "assignuserroleid", e.rowData.assignuserroleid)).subscribe(response => {
        if (response.error == true) {

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", {duration: 5000});

        } else {

          this.spinner.stop();
          this.retrieveAssignUsersRoleByDnsId();
          this.snackBar.open(response.statusMessage, "OK", {duration: 50000});
        }
      })
    }
  }


  openSaveForm(buttonName) {
    console.log(this.listObjectDropDown);
    this.buttonName = buttonName;

    let width = '80%';

    if (this.bootstrapColumn == 1) {

      width = '55%';

    }
    var obj={}
    let dialogRef = this.dialog.open(AssignUserRolePopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      this.retrieveAssignUsersRoleByDnsId();


    });
  }

  /*
      * Author: Sujeet Sharma
      * Date: 26-12-2025
      *
      * Description:
      * Enhanced Import/Export functionality to support Administration-level
      */
   importData() {
       
        let tenantid = localStorage.getItem("dnsName")
          console.log("<--- Inside upload Group Template --->")
          let width = "85%";
        let dialogRef = this.dialog.open(ImportJsonComponent, {
            maxWidth: "70vw",
            height: "50%",
            width: width,
          data: { "tablename": this.importExportTableName, "tenantid":tenantid},
            disableClose: true,
          });
        
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
        console.log("tenantid");
            //this.reportCreationData = result;
        
            //this.vaultObjectService.retrieveobjectgroup();
          });
        
        
      }
      
    
      async exportData() {
        

        this.snackBar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
        let tenantid = localStorage.getItem("dnsName")
       debugger;
    
          try {
            const blob = await this.commonService.downloadJsonFile(this.importExportTableName, tenantid);
            const link = document.createElement('a');
            const timestamp = new Date().getTime();
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.importExportTableName}_export_${timestamp}.json`;
            link.click();
            window.URL.revokeObjectURL(link.href);
    
          } catch (error) {
            console.error('Error downloading JSON:', error);
          }
        
        
      }

}
